import type { LucideIcon } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { formatCompact } from '@/lib/format'

interface StatTileProps {
  label: string
  value: number
  icon: LucideIcon
  suffix?: string
  // Icon-above-number always, instead of reverting to icon-beside-number
  // at sm and up -- for contexts where the tile itself stays narrow even
  // on desktop (e.g. three packed into half a page), where the side-by-side
  // layout never gets room to breathe the way it does in a wider grid.
  stacked?: boolean
}

export function StatTile({ label, value, icon: Icon, suffix = '', stacked = false }: StatTileProps) {
  return (
    <Card className="gap-2 py-5">
      <CardContent
        className={`flex flex-col items-center gap-2 px-5 text-center ${stacked ? '' : 'sm:flex-row sm:items-center sm:gap-4 sm:text-left'}`}
      >
        <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Icon className="size-5" strokeWidth={2} />
        </div>
        <div className={`flex flex-col items-center ${stacked ? '' : 'sm:items-start'}`}>
          <span className="text-2xl font-semibold tracking-tight">
            {formatCompact(value)}
            {suffix}
          </span>
          <span className="text-sm text-muted-foreground">{label}</span>
        </div>
      </CardContent>
    </Card>
  )
}
